import { Routes } from '@angular/router';

import { MOKABINGO_INTERNAL_ROUTES } from './mokabingo-internal.routes';

export const MOKABINGO_ROUTES: Routes = [
    {
        path: '',
        children: [...MOKABINGO_INTERNAL_ROUTES],
    },
];
